export default __webpack_public_path__ + "static/media/soloServiceIco.1abac15f.svg";